var map = {
	"./adventitious.svg": [
		9237,
		237
	],
	"./artist.svg": [
		1438,
		438
	],
	"./boiled.svg": [
		6498,
		498
	],
	"./editors.svg": [
		8491,
		491
	],
	"./favicon.svg": [
		7670,
		670
	],
	"./fe-mg.svg": [
		3440,
		440
	],
	"./grandma.svg": [
		6025,
		25
	],
	"./helsinki.svg": [
		7462,
		462
	],
	"./juurtumisharjoitus.svg": [
		4918,
		918
	],
	"./link.svg": [
		9736,
		736
	],
	"./memoria.svg": [
		2614,
		614
	],
	"./nexo.svg": [
		2988,
		988
	],
	"./routes.svg": [
		2119,
		119
	],
	"./uni.svg": [
		4434,
		434
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3897;
module.exports = webpackAsyncContext;